var map = {
	"./campopollos.jpg": 1520,
	"./finca.jpg": 5118,
	"./madera.jpg": 3765,
	"./madera1.jpg": 4833,
	"./pakpollo.png": 5322,
	"./pccpollo.png": 9824,
	"./pollo1.jpg": 8372,
	"./pollo2.jpg": 2398,
	"./pollocanal.webp": 3936,
	"./popollo.jpg": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3654;